<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-proportion-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 4v20h20c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4zm-4 4.504C13.1 10.28 8 16.544 8 24c0 8.836 7.163 16 16 16 7.455 0 13.72-5.1 15.496-12H22a2 2 0 01-2-2V8.504zm8-6.405c9.449.938 16.963 8.452 17.901 17.9H30a2 2 0 01-2-2V2.1zm4 5.063V16h8.838A16.06 16.06 0 0032 7.162z"/></svg>
</template>
<script>

export default {
  name: 'IconProportionAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
